











































import { Component, Vue } from 'vue-property-decorator';
import { TagEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stTagApi } from '@/services/st-api';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';

@Component({
  components: {
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
  },
})
export default class TagEdit extends Vue {
  private id: number = 0;
  private tag: TagEditModel = new TagEditModel();
  private loading: boolean = true;
  private saving: boolean = false;
  private listPage: string = 'Tags';

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  async mounted() {
    this.openSlideIn();
    this.tag = this.id == 0 ? await stTagApi.getNew() : await stTagApi.get(this.id);
    this.loading = false;
  }

  get colorClasses() {
    return ['bg-blue-500', 'bg-green-500', 'bg-orange-500', 'bg-red-500', 'bg-purple-500', 'bg-pink-500', 'bg-green-700', 'bg-black', 'bg-gray-500'];
  }

  async submit() {
    try {
      this.saving = true;
      if (this.tag.id == 0) {
        await stTagApi.post(this.tag);
      } else {
        await stTagApi.put(this.tag.id, this.tag);
      }
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
